import { useTranslation } from "react-i18next"
import { Flex } from "../../../components/flex/Flex"
import InfoBox from "../../../components/info/InfoBox"
import { InfoText } from "../../../components/info/InfoText"
import Slider from "../../../components/slider/Slider"
import { Spacer } from "../../../components/spacer/Spacer"
import Text from "../../../components/Text"
import { styled, theme } from "../../../styles/stitches.config"

const zeroPercentValue = 0
const hundredPercentValue = 100
const percentageStep = 25
const percentages = [0, 25, 50, 75, 100]

const SCard = styled("div", {
  backgroundColor: theme.colors.white,
  boxShadow: theme.shadows.default,
  padding: `${theme.space.s7} ${theme.space.s12}`,

  width: "100%",

  "@sm": {
    width: theme.sizes.s100,
  },
})

interface SliderProps {
  value: number
  onValueChange: (value: number) => void
}

export const OptimizationSlider = ({ value, onValueChange }: SliderProps) => {
  const { t } = useTranslation("microsite")
  return (
    <SCard>
      <Flex justify="between">
        <Flex>
          <Text type="headerH3">{t("optimization")}</Text>
          <Spacer size={theme.space.s2} />
          <InfoBox inline variant="default">
            <InfoText type="textsLarge">{t("optimization_tooltip")}</InfoText>
          </InfoBox>
        </Flex>
        <Text type="headerH2Positive">{`${value}%`}</Text>
      </Flex>

      <Spacer size={theme.space.s7} />

      <Slider
        min={zeroPercentValue}
        max={hundredPercentValue}
        step={percentageStep}
        tickValues={percentages}
        showLeftTrack
        values={[value]}
        onValuesChange={(values) => onValueChange(values[0] ?? zeroPercentValue)}
      />
    </SCard>
  )
}
